<template>
  <VueRecaptcha
    ref="captcha"
    class="captcha-container"
    :sitekey="sitekey"
    :load-recaptcha-script="true"
    @verify="onVerify"
    @expired="onExpire"
  />
</template>

<script>
import { CAPTCHA_SITE_KEY } from '@/core/constants'
export default {

  name: 'DSReCaptcha',

  components: {
    VueRecaptcha: () => import(/* webpackChunkName: "vue-recaptcha" */ 'vue-recaptcha'),
  },

  data () {
    return {
      sitekey: CAPTCHA_SITE_KEY,
    }
  },

  methods: {
    onVerify() {
      this.$emit('verified', true)
    },
    onExpire() {
      this.$emit('verified', false)
      this.$emit('expired', true)
      // TODO: is a full page refresh required?
    },
  },
}
</script>

<style lang="css">
  .captcha-container {
    margin: 1em auto 1.4em;
  }
</style>
